import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators} from '@angular/forms';
import {ErrorStateMatcher} from '@angular/material/core';
import {Router} from '@angular/router';
import {Ordered} from 'src/app/models/ordered';
import {CaexService} from 'src/app/services/caex.service';
import {CalableMemberService} from 'src/app/services/calable-member.service';
import {EmailService} from 'src/app/services/email.service';

export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-caex-payment',
  templateUrl: './caex-payment.component.html',
  styleUrls: [ './caex-payment.component.scss' ]
})
export class CaexPaymentComponent implements OnInit {

  public currentOrderd: Ordered;
  public usd_value: number;

  public orderForm: FormGroup;
  public matcher = new FormErrorStateMatcher();
  public spinner: boolean

  constructor (
    public _caexService: CaexService,
    private router: Router,
    private _formBuilder: FormBuilder,
    private _emailService: EmailService,
    private _calableMemberService: CalableMemberService
  ) {

    if (!this._caexService.currentMember || !this._caexService.currentProduct) {
      this.router.navigate([ 'caex' ]);
    }

    this.currentOrderd = this._caexService.currentOrdered

   // console.log('updateMemberSituation: ' + this._caexService.updateMemberSituation)
  //  console.log('currentOrderd ' + JSON.stringify(this.currentOrderd))

    this.usd_value = this._caexService.currentOrdered.value / this._caexService.dolarCotation

    this.orderForm = this._formBuilder.group({
      tid: new FormControl('', [ Validators.required ])
    });

  }

  ngOnInit () {
  }

  saveOrder () {

    if (this.orderForm.valid) {
      this.spinner = true
      this.currentOrderd.Tid = this.orderForm.controls.tid.value

      this._caexService.currentOrdered = this.currentOrderd
      this._caexService.memberOrders.push(this.currentOrderd)

     //  console.log("this.currentOrderd : " + JSON.stringify(this.currentOrderd))
     //  this.router.navigate([ 'toten/' + this._caexService.currentMember.cpf ]);
      
      this._caexService.insertOrder(this.currentOrderd)
        .then((result) => {
          this.currentOrderd.id = result.id

          //this.sendEmailOrderConfirmation(this.currentOrderd)
          //this.sendReceipt(this.currentOrderd)

          this.router.navigate([ 'toten/' + this._caexService.currentMember.cpf ]);
        })
        .catch(() => {
          console.log("error")
        })
        .finally(() => {
          this.spinner = false
        })
        

    }


  }

  sendEmailOrderConfirmation (order) {

    let html: any = ""

    html += "<div>"

    html += "<div>"
    html += "Prezado(a) " + order.member_name
    html += "</div>"

    html += "<br>"

    html += "<div>"
    html += "Servimo-nos da presente para confirmar sua inscrição."
    html += "</div>"

    html += "<div>"
    html += order.product_name
    html += "</div>"

    html += "<br>"

    html += "<div>"
    html += "Categoria: " + order.category_name
    html += "</div>"

    html += "<div>"
    html += "Valor: " + order.total
    html += "</div>"

    html += "<br>"

    html += "<br>"

    html += "<div>"
    html += "Gratos por sua participação,"
    html += "</div>"

    html += "<div>"
    html += "<b>Tesouraria SBCCV</b>"
    html += "</div>"

    html += "</div>"

    this._emailService.sendStandardEmail({
      'subject': "SBCCV - Confirmação de inscrição",
      'html': html,
      'from': "SBCCV <cientifico@sbccv.org.br>",
      'to': order.member_email,
      //  'bcc': "cientifico@sbccv.org.br"
    })
      .then(() => {
        console.log("email enviado com sucesso")
        this.sendReceipt(order)
      })
      .catch((error) => {
        console.log("send email schedule error")
      })

  }

  sendReceipt (order) {
    this._calableMemberService.requestReceipt(order.id)
      .then(() => {
        console.log("recibo enviado")
      })
      .catch(() => {
        console.log("erro ao enviar recibo.")
      })
  }


  goBack () {
    this.router.navigate([ 'caex' ]);
  }

}

